var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSilverRank2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "silver_rank_2_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 22,
    width: 192,
    height: 154
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.788 22H4v154h191.788V22z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#silver_rank_2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.647 25.249c-5.104-5.285-13.96-3.915-17.222 2.639a46.362 46.362 0 008.226 52.959c17.597 18.228 46.529 19.41 65.579 3.028L39.647 25.25z",
    fill: "#DCDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.673 60.45c-7.079-2.112-14.094 3.4-13.654 10.682 1.147 19.027 14.093 36.206 33.672 42.044 24.427 7.283 50.18-5.787 58.54-29.307l-78.558-23.42z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.736 103.977c-7.168 1.81-10.27 10.11-6.072 16.111 10.978 15.684 31.073 23.771 50.887 18.757 24.721-6.252 39.885-30.589 34.68-54.976L55.606 94.143l-38.865 9.828-.006.006z",
    fill: "#D2D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.141 25.249c5.103-5.285 13.959-3.915 17.222 2.639a46.362 46.362 0 01-8.226 52.959c-17.597 18.228-46.529 19.41-65.579 3.028l56.583-58.626z",
    fill: "#DCDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.115 60.45c7.085-2.112 14.094 3.4 13.654 10.682-1.147 19.027-14.093 36.206-33.672 42.044-24.427 7.283-50.18-5.787-58.539-29.307l78.551-23.42h.006z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.051 103.977c7.168 1.81 10.271 10.11 6.072 16.111-10.977 15.684-31.072 23.771-50.887 18.757-24.72-6.252-39.884-30.589-34.679-54.976l40.623 10.274 38.865 9.828.006.006z",
    fill: "#D2D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.675 26.958h103.336c6.173 0 11.194 4.945 11.194 11.04v76.008c0 34.214-28.167 61.994-62.859 61.994s-62.859-27.78-62.859-61.994V37.998c0-6.088 5.014-11.04 11.194-11.04h-.006z",
    fill: "#CDCBCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M64.342 52.771h72.008c4.307 0 7.799 3.443 7.799 7.691v46.531c0 23.84-19.63 43.2-43.803 43.2-24.172 0-43.802-19.36-43.802-43.2v-46.53c0-4.249 3.491-7.692 7.798-7.692z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.35 55.285c2.893 0 5.25 2.324 5.25 5.177v46.531c0 22.432-18.508 40.686-41.254 40.686-22.745 0-41.254-18.254-41.254-40.686v-46.53c0-2.854 2.357-5.178 5.25-5.178h72.008zm0-2.514H64.342c-4.307 0-7.798 3.443-7.798 7.691v46.531c0 23.859 19.61 43.2 43.802 43.2s43.803-19.341 43.803-43.2v-46.53c0-4.249-3.492-7.692-7.799-7.692z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.713 26.958l-33.226 32.77v48.635l82.534-81.405H70.713zM95.39 94.928l65.063-64.168a11.22 11.22 0 00-8.436-3.802h-15.654l-54.946 54.19 13.972 13.78z",
    fill: "#fff",
    opacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverRank2);
export default ForwardRef;